<template>
  <div class="monitor-box h-full" ref="monitorBoxRef">
    <div class="monitor-standard">
      <el-select
        size="small"
        placeholder="请选择标准库"
        v-model="standardId"
        filterable
        @change="swtichPeriod"
      >
        <el-option
          v-for="item in standardList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>
    <div class="monitor-name">
      <div class="monitor-title">数据采集综合监控</div>
    </div>
    <el-tabs v-model="activeTab" :lazy="false" class="h-full">
      <el-tab-pane label="实体数据采集" name="acquisitionMonitoring" class="h-full overflow-y-auto">
        <DataCollectionMonitoring :standardId="currentStandard" />
      </el-tab-pane>
      <el-tab-pane label="时序数据采集" name="timeServiceMonitoring" class="h-full overflow-y-auto">
        <TimeServiceMonitoring :standardId="currentStandard" />
      </el-tab-pane>
      <el-tab-pane
        label="数字化移交监控"
        name="digitalTransferMonitoring"
        class="h-[calc(100vh-190px)] overflow-y-auto"
      >
        <!-- 此处使用iframe -->
        <iframe
          :src="iframeUrl"
          @load="loadFinish"
          width="100%"
          class="iframe-box"
          :style="{
            height: iframeHeight,
          }"
          style="background-color: transparent;"
          ref="iframeRef"
        ></iframe>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TimeServiceMonitoring from './TimeServiceMonitoring'
// import DataCollectionMonitoring from '../dataCollectionManage/monitor'
import DataCollectionMonitoring from './dataCollectionMonitoring'

import StandardManagementService from '@/services/common/StandardManagementService'

export default {
  name: 'IndexMonitor',
  components: {
    TimeServiceMonitoring,
    DataCollectionMonitoring,
  },
  data() {
    return {
      activeTab: 'acquisitionMonitoring',
      standardId: '', // 标准库id
      standardList: [], // 标准库列表
      currentStandard: '',
      iframeUrl: 'about:blank',
      // 'http://resource-c2.wiz.top:8888/#/report/bigscreen/viewer?reportCode=DigitalMonitor&ShowClassicTop=false&ShowClassicLeft=false',
      iframeHeight: '0px',
    }
  },
  computed: {
    config() {
      return Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config || {}
    },
  },
  methods: {
    getHeight() {
      const equipment = document.body.clientWidth
      const ratioEquipment = this.$refs.monitorBoxRef.offsetWidth / equipment
      this.iframeHeight = `${1080 * ratioEquipment}px`
    },
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        this.standardId = this.standardList[0]?.id
        this.currentStandard = this.standardList[0]?.id
      }
    },
    swtichPeriod(value) {
      this.currentStandard = value
    },
    loadFinish() {
      console.log('加载完成')
      this.getHeight()
    },
  },
  async created() {
    await this.getStandardList()
  },
  async mounted() {
    this.$nextTick(async () => {
      // 优先获取settings中模块配置的地址，没有则获取系统设置中的配置（兼容历史版本）
      const urlConfig = window.top.V8?.SysConfig?.ExtraConfig
      if (this.config.dataMonitorAddress) {
        this.iframeUrl = this.config.dataMonitorAddress
      } else if (urlConfig) {
        this.iframeUrl = JSON.parse(urlConfig).VUE_APP_DATAMONITOR_ADDRESS
      }
      // 测试地址
      // this.iframeUrl =
      //   'http://resource-c2.wiz.top:8888/#/report/bigscreen/viewer?reportCode=DigitalMonitor&ShowClassicTop=false&ShowClassicLeft=false'
    })
  },
}
</script>

<style lang="scss" scoped>

.monitor-box {
  position: relative;
}
.monitor-box ::v-deep .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
  align-items: center;
}
.monitor-box ::v-deep .el-tabs__nav-wrap:after {
  height: 0px;
}
.monitor-box ::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}
.monitor-standard {
  position: absolute;
  z-index: 10;
  right: 0px;
  top: 0px;
}
.monitor-name {
  position: absolute;
  z-index: 10;
  left: 0px;
  top: 0px;
  .monitor-title {
    font-size: 22px;
    line-height: 40px;
    font-weight: bold;
  }
}

</style>
